import { Injectable } from '@angular/core';
import { RatingLevels } from '../../../core/model/rating-levels';
import { Organization } from '../../companies/model/organization';
import { Company } from '../../companies/model/company';

@Injectable()
export class HazardTypesService {
  getHazardTypes(organization: Organization | Company): string[] {
    return organization.settings.isAmazonHazardType ? RatingLevels.hazardTypesAmazon : RatingLevels.hazardTypes;
  }
}
